<template>
  <div id="KenshinJudgmentOrderDetailone">
    <div id="container">
      <div class="labelTitle lable">検診結果詳細</div>
      <div style="margin-top:15px; width:100%; display:inline-block;">
        <span style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word; float:left; margin-left:20px;font-size:20px;text-align:left;">企業名：{{companyName}}</span>
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
      <div id="item-contens" class="judgment-area">
        <div class="card-content margin-top">
          <span style="font-size:20px;">{{modelName}} 測定結果</span>
          <table v-if="isWP" id="KenshinJudgmentDetailTable">
            <!-- WP用表示テーブル -->
            <tr><th>受付番号</th><td>{{data.receiptNumber}}</td><th>開始日</th><td>{{data.startDate}}</td><th>SPO2最低</th><td>{{data.SPO2Minimum}}</td></tr>
            <tr><th>社員番号</th><td>{{data.employeeNumber}}</td><th>開始時間</th><td>{{data.startTime}}</td><th>脈拍平均</th><td>{{data.pulseAverage}}</td></tr>
            <tr><th>名前</th><td>{{data.name}}</td><th>終了日</th><td>{{data.endDate}}</td><th>脈拍最低</th><td>{{data.pulseLowest}}</td></tr>
            <tr><th>性別</th><td>{{data.gender}}</td><th>終了時間</th><td>{{data.endTime}}</td><th>酸素90未満</th><td>{{data.oxygenLess90}}</td></tr>
            <tr><th>生年月日</th><td>{{data.birthday}}</td><th>測定時間</th><td>{{data.measurementTime}}</td><th>酸素88未満</th><td>{{data.oxygenLess88}}</td></tr>
            <tr><th>年齢</th><td>{{data.age}}</td><th>睡眠時間</th><td>{{data.sleepTime}}</td><th>酸素85未満</th><td>{{data.oxygenLess85}}</td></tr>
            <tr><th>身長</th><td>{{data.height}}</td><th>ODI4</th><td>{{data.odi4}}</td><th>酸素80未満</th><td>{{data.oxygenLess80}}</td></tr>
            <tr><th>体重</th><td>{{data.weight}}</td><th>RDI</th><td>{{data.rdi}}</td><th>酸素70未満</th><td>{{data.oxygenLess70}}</td></tr>
            <tr><th>BMI</th><td>{{data.bmi}}</td><th>AHI</th><td>{{data.ahi}}</td><th>いびき40dB率</th><td>{{data.snoring40dBRate}}</td></tr>
            <tr><th>検査ID</th><td>{{data.inspectionId}}</td><th>SPO2中央</th><td>{{data.SPO2Center}}</td><th>セルフチェック</th><td>{{data.selfCheck}}</td></tr>
            <tr>
              <th>レポート</th>
              <td colspan="5">
                <ul class="report-list">
                    <li v-for="(report,index) in data.reportList" :key="index"><a @click="downloadFile(report.fileAddress, report.fileId)"><b-icon icon="paperclip" />{{report.name}}</a></li>
                </ul>
              </td>
            </tr>
          </table>
          <table v-else-if="isSimonJ" id="KenshinJudgmentDetailTable">
            <!-- simonJ用表示テーブル -->
            <tr><th>受付番号</th><td>{{data.receiptNumber}}</td><th>体重</th><td>{{data.weight}}</td><th>ODI3</th><td>{{data.odi3}}</td></tr>
            <tr><th>社員番号</th><td>{{data.employeeNumber}}</td><th>BMI</th><td>{{data.bmi}}</td><th>SPO2平均値</th><td>{{data.SPO2Center}}</td></tr>
            <tr><th>名前</th><td>{{data.name}}</td><th>患者ID</th><td>{{data.inspectionId}}</td><th>SPO2最低値</th><td>{{data.SPO2Minimum}}</td></tr>
            <tr><th>性別</th><td>{{data.gender}}</td><th>測定日</th><td>{{data.startDate}}</td><th>SPO2低下数</th><td>{{data.SPO2Declines}}</td></tr>
            <tr><th>生年月日</th><td>{{data.birthday}}</td><th>開始時刻</th><td>{{data.startTime}}</td><th>脈拍平均</th><td>{{data.pulseAverage}}</td></tr>
            <tr><th>年齢</th><td>{{data.age}}</td><th>測定時間</th><td>{{data.measurementTime}}</td><th>セルフチェック</th><td>{{data.selfCheck}}</td></tr>
            <tr><th>身長</th><td>{{data.height}}</td><th>解析時間</th><td>{{data.analysisTime}}</td></tr>
            <tr>
              <th>レポート</th>
              <td colspan="5">
                <ul class="report-list">
                    <li v-for="(report,index) in data.reportList" :key="index"><a @click="downloadFile(report.fileAddress, report.fileId)"><b-icon icon="paperclip" />{{report.name}}</a></li>
                </ul>
              </td>
            </tr>
          </table>
          <table v-else id="KenshinJudgmentDetailTable">
            <!-- WP以外用表示テーブル -->
            <tr><th>受付番号</th><td>{{data.receiptNumber}}</td><th>BMI</th><td>{{data.bmi}}</td><th>ODI4</th><td>{{data.odi4}}</td></tr>
            <tr><th>社員番号</th><td>{{data.employeeNumber}}</td><th>検査ID</th><td>{{data.inspectionId}}</td><th>ODI3</th><td>{{data.odi3}}</td></tr>
            <tr><th>名前</th><td>{{data.name}}</td><th>開始日</th><td>{{data.startDate}}</td><th>ODI2</th><td>{{data.odi2}}</td></tr>
            <tr><th>性別</th><td>{{data.gender}}</td><th>開始時間</th><td>{{data.startTime}}</td><th>SPO2中央</th><td>{{data.SPO2Center}}</td></tr>
            <tr><th>生年月日</th><td>{{data.birthday}}</td><th>終了日</th><td>{{data.endDate}}</td><th>SPO2最低</th><td>{{data.SPO2Minimum}}</td></tr>
            <tr><th>年齢</th><td>{{data.age}}</td><th>終了時間</th><td>{{data.endTime}}</td><th>脈拍中央</th><td>{{data.pulseAverage}}</td></tr>
            <tr><th>身長</th><td>{{data.height}}</td><th>測定時間</th><td>{{data.measurementTime}}</td><th>&lt;90%時間</th><td>{{data.lessThan90Time}}</td></tr>
            <tr><th>体重</th><td>{{data.weight}}</td><th>睡眠時間</th><td>{{data.sleepTime}}</td><th>&lt;90%割合</th><td>{{data.lessThan90Ratio}}</td></tr>
            <tr><th>セルフチェック</th><td>{{data.selfCheck}}</td></tr>
            <tr>
              <th>レポート</th>
              <td colspan="5">
                <ul class="report-list">
                    <li v-for="(report,index) in data.reportList" :key="index"><a @click="downloadFile(report.fileAddress, report.fileId)"><b-icon icon="paperclip" />{{report.name}}</a></li>
                </ul>
              </td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button class="is-primary" icon-left="offer" @click="judgmentRequest">判定依頼</b-button>
          <b-button class="is-primary" icon-left="file-undo-outline" @click="returnData">抽出に戻す</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "KenshinJudgmentOrderDetailone",
  methods: {
    back: function () {
      this.$router.push({
        name: "KenshinJudgmentOrderDetailList",
        params: {
          receiptNumber:this.targetNumber,
          searchConditions: this.searchParams
        },
      });
    },
    downloadFile: function(fileAddress, fileId){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getDownloadFilePOST({
            body:{
              fileId:fileId,
              fileName:fileAddress
            }
          });
        },
        function(result){
          if(result != null && result.status == 200){
            var downloadUrl = result.obj.downloadUrl;
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = downloadUrl;
            let targetFile = fileAddress.toLowerCase();
            if(targetFile.endsWith(".pdf")){
                a.target="_blank"
            }
            a.click();
            a.remove();
          } else if(result != null){
            _this.showErrorMessage(result.message);
          } else {
            _this.showErrorMessage("予期しないエラーが発生しました。");
          }
        },
        function(error){
          // エラーメッセージ表示
          _this.showErrorMessage(error);
        }
      );
    },
    judgmentRequest: function() {
      var excuteApi = this.setKenshinJudgmentRequestPOST;
      var successCallBack = this.setKenshinJudgmentRequestPOSTSuccess;
      var errorCallBack = this.setKenshinJudgmentRequestPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinJudgmentRequestPOST: function(client) {
      var receiptNumber = [this.data.receiptNumber]
      return client.apis.internalKenshin.setKenshinJudgmentRequestPOST({
        body:{
          receiptNumber:receiptNumber,
          version:this.version
        }
      });
    },
    setKenshinJudgmentRequestPOSTSuccess: function(result) {
      this.showSuccess(result,this.back());
    },
    setKenshinJudgmentRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    returnData: function() {
      var excuteApi = this.setReturnKenshinDataExtractionPOST;
      var successCallBack = this.setReturnKenshinDataExtractionPOSTSuccess;
      var errorCallBack = this.setReturnKenshinDataExtractionPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setReturnKenshinDataExtractionPOST: function(client) {
      return client.apis.internalKenshin.setReturnKenshinDataExtractionPOST({
        body:{
          receiptNumber:this.data.receiptNumber,
          version:this.version
        }
      });
    },
    setReturnKenshinDataExtractionPOSTSuccess: function(result) {
      this.showSuccess(result,this.back());
    },
    setReturnKenshinDataExtractionPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  data() {
    var companyName = this.$route.params["companyName"];
    var data = this.$route.params["data"];
    var targetNumber = this.$route.params["targetNumber"];
    var searchParams = this.$route.params["searchParams"];
    var modelName = this.$route.params["model"];
    var isWP = this.$route.params["isWP"];
    var isSimonJ = this.$route.params["isSimonJ"];
    var version = this.$route.params["version"];
    return {
      targetNumber,
      searchParams,
      companyName,
      data,
      modelName,
      isWP,
      isSimonJ,
      version
    };
  },
  filters: {},
  components: {
  },
  mounted: function () {},
};
</script>
<style lang="scss" scoped>
.postion-left {
    float:left;
    margin-left:10px;
}
.fontSize20 {
    font-size: 20px;
}

table#KenshinJudgmentDetailTable tr th {
  width: 10% !important;
}
table#KenshinJudgmentDetailTable tr td {
  word-break : break-all !important;
  width: 20% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinJudgmentOrderDetailone.vue